import React, { useContext, useEffect, useState } from "react";
import LeaveDashboard from "./LeaveDashboard";
import AttendanceDashboard from "./AttendanceDashboard";
import OnboardingDashboard from "./OnboardingDashboard";
import SalaryDashboard from "./SalaryDashboard";
import EmployeesDashboard from "./EmployeesDashboard";
import ProjectionDashboard from "./ProjectionDashboard"
import { encodeData , decodeData, findModuleByRoute } from "../../Constants/constants";
import { useLocation, useNavigate } from "react-router-dom";
import { ConfigContext } from "../../Context/ConfigContext";
import { HmacSHA1 } from "crypto-js";



const Dashboard = () => {
  const { apiURL, apiHeaderFile, apiHeaderJSON,permissions } = useContext(ConfigContext);
  
   const locationParams = useLocation();
    const queryParams = new URLSearchParams(locationParams.search);
    const encodedData = queryParams.get("abs");

    let leave = findModuleByRoute(permissions,"ApprovedLeave");
    let onboarding = findModuleByRoute(permissions, "EmployeeOnboarding") || findModuleByRoute(permissions, "GuestEmployee")
    let employees = findModuleByRoute(permissions,"CandidateDetailsList");
    let attendance = findModuleByRoute(permissions,"AttendanceReport");
    let salary = findModuleByRoute(permissions,"SalaryReport");
    let insights = findModuleByRoute(permissions,"SalaryReport");
    useEffect(() => {
      if (onboarding) {
        setActiveComponent("OnboardingDashboard");
      } else if (employees) {
        setActiveComponent("EmployeesDashboard");
      } else if (leave) {
        setActiveComponent("LeaveDashboard");
      } else if (attendance) {
        setActiveComponent("AttendanceDashboard");
      } else if (salary) {
        setActiveComponent("SalaryDashboard");
      } else if (insights) {
        setActiveComponent("ProjectionDashboard");
      } else {
        setActiveComponent(null); 
      }
    }, [onboarding, employees, leave, attendance, salary, insights]);
    const [activeComponent, setActiveComponent] = useState(null);

    const componentMap = {
      OnboardingDashboard: onboarding && <OnboardingDashboard /> ? "nav-link-active" : "",
      EmployeesDashboard: employees && <EmployeesDashboard /> ? "nav-link-active" : "",
      LeaveDashboard: leave && <LeaveDashboard /> ? "nav-link-active" : "",
      AttendanceDashboard: attendance && <AttendanceDashboard /> ? "nav-link-active" : "",
      SalaryDashboard: salary && <SalaryDashboard /> ? "nav-link-active" : "",
      ProjectionDashboard: insights && <ProjectionDashboard />? "nav-link-active" : ""
    };
    const availableComponentKeys = Object.keys(componentMap).filter(key => componentMap[key]);
    
   const availableComponenets = [
    employees && <EmployeesDashboard />,
    onboarding && <OnboardingDashboard />,
    leave && <LeaveDashboard />,
    attendance && <AttendanceDashboard />,
    salary && <SalaryDashboard />,
    insights && <ProjectionDashboard />
  ].filter(Boolean)
   

  const renderComponent = () => {
    if (!activeComponent){
      return (
        <div className="d-flex justify-content-center">
          <h5>Welcome To AbStart</h5>
        </div>
      );
      
    }
    switch (activeComponent) {
    case "OnboardingDashboard":
      return <OnboardingDashboard />;
    case "EmployeesDashboard":
      return <EmployeesDashboard />;
    case "LeaveDashboard":
      return <LeaveDashboard />;
    case "AttendanceDashboard":
      return <AttendanceDashboard />;
    case "SalaryDashboard":
      return <SalaryDashboard />;
    case "ProjectionDashboard":
      return <ProjectionDashboard />;
    default:
      return availableComponenets[0]
      // return <div>No dashboard available.</div>;
  }
  };

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <div className="">
            <h5 className="mb-4 mt-3">Dashboard</h5>
            <div className=" card-header bg-white mb-2 px-2 pb-2 rounded-2">
                  {/* <ul className="nav nav-tabs-custom rounded card-header-tabs border-bottom-0" role="tablist">
                      <li className="nav-item" role="presentation">
                          <p className={`dashboard-nav-link mb-0 ${activeComponent==="AttendanceDashboard"  ? "nav-link-active active" : ""}`}
                          onClick={() => setActiveComponent("AttendanceDashboard")} >
                              <i className="fas fa-home" /> Attendance
                          </p>
                      </li>
                      <li className="nav-item" role="presentation">
                          <p className={`dashboard-nav-link mb-0 ${activeComponent==="OnboardingDashboard"  ? "nav-link-active active" : ""}`}
                          onClick={() => setActiveComponent("OnboardingDashboard")} >
                              <i className="fas fa-home" /> Onboarding
                          </p>
                      </li>
                      <li className={`nav-item`} role="presentation">
                          <p className={`dashboard-nav-link mb-0 ${activeComponent==="EmployeesDashboard"  ? "nav-link-active active" : ""}`}
                          onClick={() => setActiveComponent("EmployeesDashboard")} >
                              <i className="far fa-user" /> Employees
                          </p>
                      </li>
                      <li className={`nav-item`} role="presentation">
                          <p className={`dashboard-nav-link mb-0 ${activeComponent==="LeaveDashboard"  ? "nav-link-active active" : ""}`}
                          onClick={() => setActiveComponent("LeaveDashboard")} >
                              <i className="far fa-envelope" /> Leave
                          </p>
                      </li>
                      <li className={`nav-item`} role="presentation">
                          <p className={`dashboard-nav-link mb-0 ${activeComponent==="SalaryDashboard"  ? "nav-link-active active" : ""}`}
                          onClick={() => setActiveComponent("SalaryDashboard")} >
                              <i className="far fa-envelope" /> Salary
                          </p>
                      </li>
                  </ul> */}
                  <ul
                    className="nav nav-tabs-custom rounded card-header-tabs border-bottom-0"
                    role="tablist"
                  >
                    {onboarding && (
                    <li className="nav-item mb-1" role="presentation">
                      <p
                        className={`dashboard-nav-link mb-0 ${
                          activeComponent === "OnboardingDashboard" ? "nav-link-active" : ""
                        }`}
                        onClick={() => setActiveComponent("OnboardingDashboard")}
                      >
                        <i className="fas fa-home" /> Onboarding
                      </p>
                    </li>)}
                    {employees && (
                        <li className="nav-item mb-1" role="presentation">
                        <p
                          className={`dashboard-nav-link mb-0 ${
                            activeComponent === "EmployeesDashboard" ? "nav-link-active" : ""
                          }`}
                          onClick={() => setActiveComponent("EmployeesDashboard")}
                        >
                          <i className="far fa-user" /> Employees
                        </p>
                      </li>
                    )}
                    {(attendance &&
                     <li className="nav-item mb-1" role="presentation">
                     <p
                       className={`dashboard-nav-link mb-0 ${
                         activeComponent === "AttendanceDashboard" ? "nav-link-active" : ""
                       }`}
                       onClick={() => setActiveComponent("AttendanceDashboard")}
                     >
                       <i className="fas fa-home" /> Attendance
                     </p>
                   </li>
                    )}
                    {(leave &&
                     <li className="nav-item mb-1" role="presentation">
                     <p
                       className={`dashboard-nav-link mb-0 ${
                         activeComponent === "LeaveDashboard" ? "nav-link-active" : ""
                       }`}
                       onClick={() => setActiveComponent("LeaveDashboard")}
                     >
                       <i className="far fa-envelope" /> Leave
                     </p>
                   </li>
                    )}
                    {(salary &&
                      <li className="nav-item mb-1" role="presentation">
                      <p
                        className={`dashboard-nav-link mb-0 ${
                          activeComponent === "SalaryDashboard" ? "nav-link-active" : ""
                        }`}
                        onClick={() => setActiveComponent("SalaryDashboard")}
                      >
                        <i className="far fa-envelope" /> Salary
                      </p>
                    </li>
                    )}
                   {(insights &&
                     <li className="nav-item mb-1" role="presentation">
                     <p
                       className={`dashboard-nav-link mb-0 ${
                         activeComponent === "ProjectionDashboard" ? "nav-link-active" : ""
                       }`}
                       onClick={() => setActiveComponent("ProjectionDashboard")}
                     >
                       <i className="far fa-envelope" /> Insights
                     </p>
                   </li>
                   )}
                   
                  </ul>

            </div>
            <div className="card-body ">
                  <div className="tab-content">
                      <div>
                        {renderComponent()}
                      </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;



